import { convertToDefEventPara } from "../../shared/utility";
import { classNames } from "primereact/utils";
import { Calendar } from "primereact/calendar";

export default function DatePickerInput(props) {
  const {
    classes,
    label,
    name,
    onChange,
    value,
    labelOn,
    error,
    explanation,
    labelDivClass,
    labelClass,
    dateFormat,
    ...other
  } = props;

  return (
    <div>
      {labelOn ? (
        <div className={classNames("flex space-x-2 mb-1", labelDivClass)}>
          <label
            htmlFor={name}
            className={classNames(
              "block text-sm font-medium text-gray-900",
              labelClass
            )}
          >
            {label}
          </label>
        </div>
      ) : null}
      <div>
        <Calendar
          value={value ? new Date(value) : null}
          onChange={(e) =>
            onChange(convertToDefEventPara(name, e.target.value))
          }
          dateFormat="M dd, yy"
          touchUI={true}
          className="date-picker block w-full focus:outline-none sm:text-sm sm:max-w-xs md:max-w-full"
          {...other}
        />
        {error ? <p className="font-medium text-red-500">{error}</p> : null}
      </div>
    </div>
  );
}
